import { LoginWorkflowLayout } from "components/app/login-workflow-layout";
import { Checkbox } from "components/ui/checkbox";
import { defaultLinkStyle } from "components/ui/link";
import { PrimaryButton } from "components/ui/primary-button";
import React, { ChangeEvent, FormEvent, MouseEvent, useEffect, useState } from "react";
import { useQueryClient } from "react-query";
import { useDispatch, useSelector } from "react-redux";
import { signEula } from "store/actions/session";
import { ApplicationState } from "store/state"; // Adjust the import path as necessary
import { push } from "util/history";

export const Eula: React.FC = () => {
    const dispatch = useDispatch();

    const userPayload = useSelector((state: ApplicationState) => {
        return state.eula.userPayload;
    });

    const [termsChecked, setTermsChecked] = useState<boolean>(false);
    const [privacyChecked, setPrivacyChecked] = useState<boolean>(false);
    const queryClient = useQueryClient();

    useEffect(() => {
        if (!userPayload?.userRecord?.id) {
            push("/login");
        }
    }, [userPayload]);

    if (!userPayload?.userRecord?.id) {
        return null;
    }

    const bothChecked = termsChecked && privacyChecked;

    const handleSubmit = (
        e: FormEvent<HTMLFormElement> | MouseEvent<HTMLButtonElement>,
    ): void => {
        e.preventDefault();
        if (bothChecked) {
            signEula(userPayload, queryClient, dispatch);
        }
    };

    const changeTermsValue = (e: ChangeEvent<HTMLInputElement>): void => {
        setTermsChecked(e.target.checked);
    };

    const changePrivacyValue = (e: ChangeEvent<HTMLInputElement>): void => {
        setPrivacyChecked(e.target.checked);
    };

    return (
        <LoginWorkflowLayout title="Terms of Service">
            <form onSubmit={handleSubmit} className="space-y-6">
                <div className="space-y-4">
                    <Checkbox
                        id="agree-terms"
                        checked={termsChecked}
                        onChange={changeTermsValue}
                        label={
                            /* eslint-disable local/no-hardcoded-brand-names */
                            <span>
                                I have read and agree to the{" "}
                                <a
                                    href="https://seniorplace.com/eula/"
                                    target="_blank"
                                    rel="noreferrer"
                                    className={defaultLinkStyle}>
                                    Terms of Service
                                </a>
                            </span>
                            /* eslint-enable local/no-hardcoded-brand-names */
                        }
                    />
                    <Checkbox
                        id="agree-privacy"
                        checked={privacyChecked}
                        onChange={changePrivacyValue}
                        label={
                            /* eslint-disable local/no-hardcoded-brand-names */
                            <span>
                                I have read and agree to the{" "}
                                <a
                                    href="https://seniorplace.com/privacy/"
                                    target="_blank"
                                    rel="noreferrer"
                                    className={defaultLinkStyle}>
                                    Privacy Policy
                                </a>
                            </span>
                            /* eslint-enable local/no-hardcoded-brand-names */
                        }
                    />
                </div>
                <PrimaryButton
                    type="submit"
                    id="proceed"
                    className="w-full"
                    disabled={!bothChecked}>
                    {bothChecked ? "I Agree" : "Please agree to both documents"}
                </PrimaryButton>
            </form>
        </LoginWorkflowLayout>
    );
};
